const INVESTMENTS_SELECTED_ROUTES = [
  { path: "/investments/*" },
  { path: "/classifications" },
  { path: "/new-transaction-wizard" },
  { path: "/manual-transaction-wizard" },
  { path: "/edit-transaction-wizard/*" },
  { path: "/add-transaction-wizard/*" },
  { path: "/dividend-planner" },
];

const DEPOTS_ACCOUNTS_ROUTES = [
  { path: "/depots-accounts/*" },
  { path: "/depots/*" },
  { path: "/accounts/*" },
];

export { INVESTMENTS_SELECTED_ROUTES, DEPOTS_ACCOUNTS_ROUTES };
